import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value"]


export default /*@__PURE__*/_defineComponent({
  __name: 'TextField',
  props: {
  value: [String, Number],
  name: {
    type: String,
    required: false,
  },
},
  emits: ['input'],
  setup(__props, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    class: "base-input__input",
    type: "text",
    name: __props.name,
    value: __props.value,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('input', $event.target.value)))
  }, null, 40, _hoisted_1))
}
}

})